import {
  IEditPromocode,
  IPromocodesFilter,
  IPromocodesIsValid,
  IPromocodeValidationErrors,
  PROMOCODE_APPLICABILITY,
  PROMOCODE_DELIVERY_TYPE,
  PROMOCODE_DISCOUNT_TYPE,
  PROMOCODE_MENU,
  PROMOCODE_PROVIDE_AS,
  PROMOCODE_SORT_COLUMN,
} from '../types/promocodes';
import { SORTING_DIRECTION } from 'src/constants/main';
import { fullWeek } from '~/constants/dateTime';

export const defaultPromocode: IEditPromocode = {
  promocode: '',
  amount: '0',
  start_date: undefined,
  end_date: undefined,
  discount_type: PROMOCODE_DISCOUNT_TYPE.AMOUNT,
  provide_as: PROMOCODE_PROVIDE_AS.DISCOUNT,
  is_all_day: true,
  delivery_types: [PROMOCODE_DELIVERY_TYPE.ALL],
  products: undefined,
  categories: undefined,
  user_limited: 0,
  usage_limited: 0,
  reoccurring_usage_limited: 0,
  reoccurring_usage_interval_type: 0,
  usage_number_per_interval: 0,
  usage_interval: 0,
  is_free_delivery: false,
  first_order: false,
  applicability: PROMOCODE_APPLICABILITY.ALL,
  minimum_order: '0',
  max_discount_amount: '',
  menu: PROMOCODE_MENU.ALL,
  customers: undefined,
  branches: undefined,
  start_time: undefined,
  end_time: undefined,
  days_of_week: fullWeek,
  allBranches: true,
  allCustomers: true,
  is_shown_as_offer: false,
};

export const defaultPromocodeFilter: IPromocodesFilter = {
  name: undefined,
  sort_field: PROMOCODE_SORT_COLUMN.START_DATE,
  sort_dir: SORTING_DIRECTION.DESCENDING,
};

export const defaultPromocodesIsValid: IPromocodesIsValid = {
  promocode: true,
  amount: true,
  max_discount_amount: true,
  start_date: true,
  end_date: true,
  discount_type: true,
  delivery_types: true,
  menu: true,
  all: false,
};

export const promocodeDeliveryTypes: PROMOCODE_DELIVERY_TYPE[] = [
  PROMOCODE_DELIVERY_TYPE.IS_DELIVERY,
  PROMOCODE_DELIVERY_TYPE.IS_PUCKUP,
  PROMOCODE_DELIVERY_TYPE.IS_CURBSIDE,
  PROMOCODE_DELIVERY_TYPE.IS_DINEIN,
];

export const defaultPromocodeValidation: IPromocodeValidationErrors = {
  descriptionEn: null,
  descriptionAr: null,
};
